import { AvailableFeaturesDocument } from "~graphql/typed-document-nodes";
import { useQuery } from "~hooks/useQuery";

export const useAvailableFeatureFlags = () => {
  const { data, error } = useQuery(AvailableFeaturesDocument);

  if (error) {
    console.error(`Failed to fetch available features: ${error.message}`);
  }

  return data?.availableFeatures?.features ?? [];
};
